export const environment = {
  production: true,
  name: 'stage',
  apiUrlMappings: {
    'stage.mipasarela.com': 'https://api-stage.mipasarela.com',
    'mce-stage.mipasarela.com': 'https://mce-api-stage.mipasarela.com',
  },
};
